// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
// import axios from 'axios'


import Vue from 'vue'
import App from './App'
import router from './router'

// import 'babel-polyfill'
import util from './common/util'
import common from "./common/common";
import Vuex from 'vuex'
import store from './store'
import globalFilter from '@/assets/js/common/globalFilter.js'  //引入公共的全局过滤器
Object.keys(globalFilter).forEach(key=>{
  Vue.filter(key, globalFilter[key])
})

window.moment=require('moment')
Vue.prototype.$ajax=axios
Vue.config.productionTip = false

import '@/assets/js/index.js'  //引入index.js文件 token登录请求反应接口

// import 'element-ui/lib/theme-chalk/index.css';
// import '../static/css/theme-green/index.css';

//编辑器
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

//拖拽组件 satrt
import VueDND from 'awe-dnd'
Vue.use(VueDND)
//拖拽组件 end
// 滚动加载
Vue.directive('dropLoad',{
    bind(el, binding) {
        const SELECTWRAP_DOM = el;
        SELECTWRAP_DOM.addEventListener('scroll', function() {
            const condition =
            SELECTWRAP_DOM.scrollHeight - SELECTWRAP_DOM.scrollTop <= SELECTWRAP_DOM.clientHeight;
            if (condition) {
                binding.value();
            }
        });
    }
})
Vue.use(VueQuillEditor)

// 限制input输入内容 https://blog.csdn.net/sd1sd2/article/details/127818207
import inputDirective from '@/common/input';
Vue.use( inputDirective )

// 覆盖element-ui的el-upload组件
import Upload from '@/components/packages/element/upload.vue'
Vue.component('ElUpload', Upload)

// 获取手机号组件
import phoneCard from '@/components/common/common/phoneCard.vue'
Vue.component('phone', phoneCard)

// el-tip-cascader 有悬浮提示的级联选择器
import elTipCascader from '@/components/common/common/cascader.vue'
Vue.component('elTipCascader', elTipCascader)
// el-tip-input 有悬浮提示的输入框
import elTipInput from '@/components/common/common/tipInput.vue'
Vue.component('elTipInput', elTipInput)
// tip-content 有悬浮提示的文字
import tipContent from '@/components/common/common/tipContent.vue'
Vue.component('tipContent', tipContent)

import Element from 'element-ui'
Element.Dialog.props.closeOnClickModal.default = false; // 全局关闭点遮罩关闭弹框

Vue.use(util);
Vue.use(common);
Vue.use(Vuex);
function deepClone(target) {
  let result;
  if (typeof target === 'object') {
      if (Array.isArray(target)) {
          result = [];
          for (let i in target) {
              result.push(deepClone(target[i]))
          }
      } else if(target===null) {
          result = null;
      } else if(target.constructor===RegExp){
          result = target;
      }else {
          result = {};
          for (let i in target) {
              result[i] = deepClone(target[i]);
          }
      }
  } else {
      result = target;
  }
  return result;
}
Vue.prototype.$deepCopy = deepClone
// process.env.MOCK && require('@/apimock') //引入模拟数据

import Print from 'vue-print-nb'
Vue.use(Print)

import '@/common/permission/index.js'

Vue.prototype.$permission = (value)=>{
    if (value) {
        const permissions = store.getters && store.getters.userInfo.jurisdict
        if (typeof value === 'string' || value instanceof String) {
            return permissions.includes(value)
        } else if (Array.isArray(value)) {
            return value.some(permission => {
                return permissions.includes(permission)
            })
        } else {
            throw new Error('permission must be String or Array')
        }
    } else {
        throw new Error(`need permission! Like hasPermission('code')`)
    }
}

// mixins
import globalMixins from '@/mixins'
Vue.mixin(globalMixins)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js